import type { CoreState } from '@/core/store/types'
import { FeatureFlags } from '@/plugins/featureFlags'

export const SET_ACTIVE_BRAND = (state: CoreState, brandId: string): void => {
  FeatureFlags.setContextField('brandId', brandId)
  state.activeBrand = brandId
}
